import React from 'react';
import { FormattedMessage } from 'react-intl';
import UtilityPageTemplate from '@templates/UtilityPageTemplate';
import { ButtonAsLink } from '@layout';
import { StyledLink } from './layout';
import messages from './messages';

export const NoPermission = ({ history, showGoBack = true }) => (
  <UtilityPageTemplate title={<FormattedMessage {...messages.title} />}>
    <p>
      <FormattedMessage {...messages.areNotAllowed} />
    </p>
    {showGoBack && (
      <p>
        Please <ButtonAsLink onClick={history.goBack}>go back</ButtonAsLink> or{' '}
        <StyledLink to="/login">login with another account</StyledLink>
      </p>
    )}
  </UtilityPageTemplate>
);



// WEBPACK FOOTER //
// ./components/pages/NoPermission/NoPermission.js